import React from "react";
import { Modal } from "antd";
import { FormInstance } from "antd/lib/form";
import { TTranslate } from "../../../service/locale/TranslationService";
import { TFormAction } from "./FormAction";

const FormComponent = ({ Form, rowData }) => {
  return React.cloneElement(Form, {
    rowData: { ...rowData }
  });
};

export interface Props {
  translate: TTranslate;
  title?: string;
  visible: boolean;
  onCreate: any;
  onCancel(args?: any): void;
  rowData?: any;
  Form: any;
  formInstance?: FormInstance;
  className: string;
  isCreateButtonEnabled?: boolean;
  okText?: string;
  cancelText?: string;
  onSubmit?(values?: any): boolean;
  formActions?: TFormAction[];
  style?: any;
}

class CreateModal extends React.Component<Props, any> {
  render() {
    const {
      translate,
      title,
      visible,
      onCreate,
      onCancel,
      Form,
      formInstance,
      className,
      isCreateButtonEnabled,
      onSubmit,
      rowData,
      okText,
      cancelText,
      style
    } = this.props;
    return (
      <Modal
        visible={visible}
        title={title}
        style={style}
        okText={okText ?? translate("modal_functions.insert_modal.add")}
        cancelText={
          cancelText ?? translate("modal_functions.insert_modal.cancel")
        }
        okButtonProps={{
          disabled:
            isCreateButtonEnabled !== undefined ? !isCreateButtonEnabled : false
        }}
        onCancel={() => {
          formInstance?.resetFields();
          onCancel();
        }}
        maskClosable={false}
        onOk={() => {
          if (onSubmit) {
            let result = onSubmit();
            if (result) {
              formInstance
                ?.validateFields()
                .then(async (values) => {
                  await onCreate(values).then((res) => {
                    formInstance.resetFields();
                    onCancel();
                  });
                })
                .catch((info) => {});
            }
          } else {
            formInstance
              ?.validateFields()
              .then(async (values) => {
                await onCreate(values).then((res) => {
                  formInstance.resetFields();
                  onCancel();
                });
              })
              .catch((info) => {});
          }
        }}
        className={"modal-position " + className}
      >
        <FormComponent Form={Form} rowData={rowData} />
      </Modal>
    );
  }
}

export default CreateModal;
